import { jsxs as e, jsx as o } from "react/jsx-runtime";
import s from "./zoom-controls.module.less.js";
const r = ({
  onZoomIn: n,
  onZoomOut: i,
  zoomInDisabled: l = !1,
  zoomOutDisabled: a = !1
}) => /* @__PURE__ */ e("div", { className: s.wrapper, children: [
  /* @__PURE__ */ o("button", { className: s.button, onClick: n, disabled: l, children: /* @__PURE__ */ o("span", { className: [s.icon, "ui-icon-plus bold"].join(" ") }) }),
  /* @__PURE__ */ o("button", { className: s.button, onClick: i, disabled: a, children: /* @__PURE__ */ o("span", { className: [s.icon, "ui-icon-minus bold"].join(" ") }) })
] });
export {
  r as ZoomControls
};
